import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_PREVIEW]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/preview/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_POPUP]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/popup/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS_RELATED_PLAN_WORKS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/related_plan_works/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_BULK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/bulk_create_plan_works/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}